import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/AnimatedTelegramBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/ChapterCosmos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/CosmicJourney.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/EditableText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/HashDeepLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/HomeCTAButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/MobilePathsTelegramHandoff.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/ParallaxChapter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/ParallaxIllustration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/PathCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/PathsHorizontalReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReorderableContainer","ReorderableSection"] */ "/opt/render/project/src/refgd/components/ReorderableSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/refgd/components/TelegramCard3D.tsx");
